import { defineMessages } from 'react-intl-next';

export const messages: {
	ai_topics_surface_header_user: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_surface_header_generic: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_surface_header_person: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_surface_header_beta_lozenge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_surface_footer_beta_lozenge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_surface_footer_content_may_vary: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_surface_footer_powered_by_ai: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_user_feedback_prompt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_page_feedback_prompt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_page_feedback_button_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_profile_feedback_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_card_header_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_card_feedback_prompt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_rovo_branding_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_show_more_topics_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_topics_show_fewer_topics_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ai_topics_surface_header_user: {
		id: 'search_ai.ai_topics.surface.header',
		defaultMessage: 'Topics this person knows about',
		description: 'Header text for the topics surface in user profiles',
	},
	ai_topics_surface_header_generic: {
		id: 'search_ai.ai_topics.related_topics.header',
		defaultMessage: 'Related topics',
		description: 'Header text for the related topics surface generically',
	},
	ai_topics_surface_header_person: {
		id: 'search_ai.ai_topics.surface.person_header',
		defaultMessage: 'Topics {userName} knows about',
		description: 'Header text for the topics surface in person cards',
	},
	ai_topics_surface_header_beta_lozenge: {
		id: 'search_ai.ai_topics.related_topics.header_beta_lozenge',
		defaultMessage: 'BETA',
		description: 'Text for the related topics header beta lozenge',
	},
	ai_topics_surface_footer_beta_lozenge: {
		id: 'search_ai.ai_topics.related_topics.footer_beta_lozenge',
		defaultMessage: 'BETA',
		description: 'Text for the related topics footer beta lozenge',
	},
	ai_topics_surface_footer_content_may_vary: {
		id: 'search_ai.ai_topics.related_topics.footer_content_may_vary',
		defaultMessage: 'Content quality may vary',
		description: 'Text for the related topics footer content may vary text',
	},
	ai_topics_surface_footer_powered_by_ai: {
		id: 'search_ai.ai_topics.related_topics.footer_powered_by_ai',
		defaultMessage: 'Powered by AI',
		description: 'Text for the related topics footer powered by AI text',
	},
	ai_topics_user_feedback_prompt: {
		id: 'search_ai.ai_topics.feedback.prompt.user',
		defaultMessage: 'Are these topics correctly associated with this user?',
		description: 'Prompt text for the feedback component for user entity',
	},
	ai_topics_page_feedback_prompt: {
		id: 'search_ai.ai_topics.feedback.prompt.page',
		defaultMessage: 'Do these topics accurately reflect the contents of this page?',
		description: 'Prompt text for the feedback component for page entity',
	},
	ai_topics_page_feedback_button_text: {
		id: 'search_ai.ai_topics.feedback.prompt.button',
		defaultMessage: 'Submit feedback',
		description: 'Button text for the feedback collector',
	},
	ai_topics_profile_feedback_text: {
		id: 'search_ai.ai_topics.profile.prompt',
		defaultMessage: 'Do these topics look accurate for this person?',
		description: 'Prompt text for feedback on profile page surface',
	},
	ai_topics_card_header_text: {
		id: 'search_ai.ai_topics.card.header',
		defaultMessage: 'Topics related to "{searchQuery}"',
		description: 'Header text for topics card in advanced search',
	},
	ai_topics_card_feedback_prompt: {
		id: 'search_ai.ai_topics.card.feedback_prompt',
		defaultMessage: 'Are these relevant to your search?',
		description: 'Prompt text for feedback on topics card in advanced search',
	},
	ai_topics_rovo_branding_text: {
		id: 'search_ai.ai_topics.rovo_branding_text',
		defaultMessage: 'Rovo',
		description: 'Text for the related topics footer branding text',
	},
	ai_topics_show_more_topics_text: {
		id: 'search_ai.ai_topics.show_more_topics_text',
		defaultMessage: 'Show more topics',
		description: 'Text for the show more topics button',
	},
	ai_topics_show_fewer_topics_text: {
		id: 'search_ai.ai_topics.show_fewer_topics_text',
		defaultMessage: 'Show fewer topics',
		description: 'Text for the show fewer topics button',
	},
});
